import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function VideoLightbox({ videoId, title, onClose }) {
  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onEsc);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!videoId) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 md:p-8" onClick={onClose} data-testid="video-lightbox">
      <div className="relative w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
        {title && (
          <div className="mb-3 flex items-center justify-between">
            <div className="text-white/95 text-[14px] font-bold">{title}</div>
            <button aria-label="Close video" onClick={onClose} data-testid="video-lightbox-close" className="grid h-9 w-9 place-items-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors">
              <X className="h-5 w-5" />
            </button>
          </div>
        )}
        <div className="relative aspect-video overflow-hidden rounded-2xl shadow-2xl bg-black">
          <iframe
            className="absolute inset-0 h-full w-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
            title={title || 'Gyan Dhara video'}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
